import { render, staticRenderFns } from "./ComponenteEcac.vue?vue&type=template&id=c95b6478&"
import script from "./ComponenteEcac.vue?vue&type=script&lang=js&"
export * from "./ComponenteEcac.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports